export const formMessages = {
    required: () => 'Required',
    numeric: () => 'Numbers only',
    objectStructure: () => 'Country object is wrong',
    isUniquePhoneNumber: () => 'Already in use'
}
